module.exports = __webpack_public_path__ + "static/media/TrashCan.57c08f04.svg";